import { createContext, useContext, useEffect, useState } from 'react';
import { api } from '@/lib/api';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [admin, setAdmin] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('kanbr_admin_token');
        if (!token) { setLoading(false); return; }
        api.get('/admin/me').then((res) => setAdmin(res.data)).catch(() => {
            localStorage.removeItem('kanbr_admin_token');
        }).finally(() => setLoading(false));
    }, []);

    const login = async (email, password) => {
        const res = await api.post('/admin/login', { email, password });
        localStorage.setItem('kanbr_admin_token', res.data.token);
        setAdmin({ email: res.data.email });
        return res.data;
    };

    const logout = () => {
        localStorage.removeItem('kanbr_admin_token');
        setAdmin(null);
    };

    return <AuthCtx.Provider value={{ admin, loading, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
